const sv = Object.freeze({
  hello: 'Hej',
  home: 'Home (sv)',
  receiptPosting: 'Receipt Posting (sv)',
  products: 'Products (sv)',
  addProduct: 'Add product (sv)',
  addNewProduct: 'Add new product (sv)',
  auctions: 'Auctions (sv)',
  welcome: 'welcome (sv)',
  reception: 'Reception',
  addReception: 'Add reception (sv)',
  seller: 'Seller (sv)',
  dateOfDropOff: 'Date of drop off (sv)',
  estimatedWorth: 'Estimated worth (sv)',
  associatedWith: 'Associated with (sv)',
  changelog: 'Changelog (sv)',
  save: 'Save (sv)',
  goBack: 'Go Back (sv)',
  UseOldProduct: 'Use old product (sv)',
  comment: 'Comment (sv)',
  description: 'Beskrivning',
  english: 'English (sv)',
  finnish: 'Finnish (sv)',
  swedish: 'Swedish (sv)',
  finland: 'Finland',
  europe: 'Europa',
  otherCountries: 'Övriga länder',
  addToAuction: 'Add to auction (sv)',
  technicalInformation: 'Technical information (sv)',
  material: 'Material (sv)',
  fitnessRating: 'Fitness rating (sv)',
  reference: 'Reference (sv)',
  year: 'Year (sv)',
  country: 'Country (sv)',
  nominalValue: 'Nominal value (sv)',
  weight: 'Weight (sv)',
  size: 'Size (sv)',
  nextSteps: 'Next steps (sv)',
  nextStep: 'Next step (sv)',
  andThen: 'And then (sv)',
  publish: 'Publish (sv)',
  saveDraft: 'Save Draft (sv)',
  editSelectedReceptions: 'Edit selected receptions (sv)',
  editReception: 'Edit reception (sv)',
  editCase: 'Redigera uppdrag',
  newCase: 'Nytt uppdrag',
  upload: 'Upload (sv)',
  uploading: 'Uploading (sv)',
  personnelAssigned: 'Personnel assigned (sv)',
  status: 'Status',
  productStatus: 'Product Status (sv)',
  featuredImage: 'Featured image (sv)',
  required: 'Required! (sv)',
  adminNote: 'Admin note (sv)',
  name: 'Name (sv)',
  condition: 'Condition (sv)',
  conditionDescription: 'Condition description (sv)',
  quantity: 'Quantity (sv)',
  ruler: 'Ruler (sv)',
  olympia: 'Olympia (sv)',
  designer: 'Designer (sv)',
  manufacturer: 'Manufacturer (sv)',
  taxableStatus: 'Taxable status (sv)',
  webShopPrice: 'Webshop price (sv)',
  purchasedPrice: 'Purchased price (sv)',
  AuctionMinimumPrice: 'Auction minimum price (sv)',
  estimatedPrice: 'Estimated price (sv)',
  productCategory: 'Product category (sv)',
  editNewProduct: 'Edit New Product (sv)',
  editProducts: 'Edit Products (sv)',
  editSelectedProducts: 'Redigera valda produkter',
  filter: 'Filter (sv)',
  inAuction: 'In auction (sv)',
  inWebshop: 'In webshop (sv)',
  notSold: 'Not sold (sv)',
  bulkEdit: 'Bulk Edit (sv)',
  image: 'image (sv)',
  date: 'Date (sv)',
  edit: 'Edit (sv)',
  assignToWoocommerce: 'Assign to woocommerce (sv)',
  AssignToAuction: 'Huutokauppaan',
  PutIntoStorage: 'Put into storage (sv)',
  holmastoWillBuyIt: 'Holmasto will buy it (sv)',
  holmastoWillSellIt: 'Holmasto will sell it on behalf of seller (sv)',
  returnToSeller: 'Return to seller (sv)',
  auction: 'Auction (sv)',
  addAuction: 'Add auction (sv)',
  auctionId: 'Auction Id (sv)',
  startDate: 'Start date (sv)',
  estimatedValue: 'Estimated value (sv)',
  categories: 'Categories (sv)',
  uncategorizedProduct: 'Products, Added to auction but not categorised (sv)',
  login: 'Login (sv)',
  forgotPassword: 'Forgot password (sv)',
  resetPassword: 'Reset password (sv)',
  notValidEmail: 'Should be a valid email! (sv)',
  backToLogin: 'Back to Login (sv)',
  createdAt: 'Created at (sv)',
  email: 'Email',
  users: 'Users (sv)',
  addUser: 'Add user (sv)',
  firstName: 'Förnamn',
  lastName: 'Efternamn',
  postalCode: 'Postal code (sv)',
  admin: 'Admin (sv)',
  shippingContainer: 'Shipping container (sv)',
  small: 'Small (sv)',
  medium: 'Medium (sv)',
  large: 'Large (sv)',
  requiresSpecialHandling: 'Requires special handling (sv)',
  owner: 'Owner (sv)',
  proposedPrice: 'Proposed price (sv)',
  proposalText: 'Proposal text (sv)',
  city: 'City',
  areYouSure: 'Are you sure? (sv)',
  cancel: 'Cancel (sv)',
  delete: 'Delete (sv)',
  thisActionCanNotBeUndone: 'This action can not be undone! (sv)',
  warehouseId: 'warehouse ID (sv)',
  lengthShouldBe1: 'Length should Be 1 (sv)',
  onlyCapitalAlphabeticChars: 'Only capital alphabetic character (sv)',
  addClient: 'Add Client (sv)',
  active: 'Active (sv)',
  inactive: 'Inactive (sv)',
  pending: 'Pending (sv)',
  holmasto: 'Holmasto (sv)',
  customer: 'Customer (sv)',
  itemStatus: 'Item Status (sv)',
  noImage: 'NO IMAGE (sv)',
  noInformation: 'NO INFORMATION (sv)',
  createCategory: 'Create Category (sv)',
  editCategory: 'Edit Category (sv)',
  label: 'Label (sv)',
  categoryImage: 'Category Image (sv)',
  chooseImage: 'Choose Image (sv)',
  choose: 'Choose (sv)',
  category: 'Category (sv)',
  productsYoureEditing: "Products you're editing (sv)",
  changeFieldsToUpdate: 'Change fields to update (sv)',
  updateAll: 'Update All (sv)',
  auctionCategory: 'Auction Category (sv)',
  productCategories: 'Product Categories (sv)',
  sku: 'SKU',
  maxLengthIsThree: 'Field contain max 3 characters (sv)',
  editAuction: 'Edit Auction (sv)',
  generatePdf: 'Generate PDF (sv)',
  markAsComplete: 'Mark as Complete (sv)',
  experts: 'Experts (sv)',
  completed: 'Completed (sv)',
  incomplete: 'Incomplete (sv)',
  canBeSentByAssignedPersona: 'Proposal can be sent by Assigned user only (sv)',
  sendProposal: 'Send proposal (sv)',
  publishForPrebid: 'Publish for Prebid (sv)',
  editUser: 'Edit User (sv)',
  from: 'From (sv)',
  to: 'To (sv)',
  images: 'Images (sv)',
  superAdmin: 'Super Admim (sv)',
  role: 'Role (sv)',
  client: 'Client (sv)',
  disable: 'Disable (sv)',
  enable: 'Enable (sv)',
  parent: 'Parent (sv)',
  newPasswordWasSentToUser: 'New password was sent to the user (sv)',
  changePassword: 'Change Password (sv)',
  profile: 'Profile (sv)',
  logOut: 'Log out (sv)',
  password: 'Password (sv)',
  confirmPassword: 'Confirm Password (sv)',
  passwordsDoesntMatch: "Passwords doesn't match (sv)",
  passwordWasUpdated: 'Password was updated (sv)',
  profileWasUpdated: 'Profile was updated (sv)',
  passwordShouldBemoreThen6Chars: 'Password should be more then 6 characters (sv)',
  wrongPassword: 'Wrong password (sv)',
  currentPassword: 'Current Password (sv)',
  mightBuyLabel: 'Includes products Holmasto might buy (sv)',
  soldOnBehalfLabel: 'Includes products sold on behalf of the customers (sv)',
  internalNote: 'Internal Note (sv)',
  startDatePreBid: 'Prebid Start (sv)',
  createTag: 'Create tag (sv)',
  endDatePreBid: 'Pre-Bid End Date (sv)',
  auctionIdShouldBeUnique: 'Auction id should be unique (sv)',
  more: 'More (sv)',
  less: 'Less (sv)',
  itemNumber: 'Item Number (sv)',
  dateTime: 'Datetime (sv)',
  user: 'User (sv)',
  userId: 'User Id (sv)',
  bid: 'Bid (sv)',
  bids: 'Bids (sv)',
  amount: 'Belopp',
  addBid: 'Add Bid (sv)',
  minimumAmountIs: 'Minimum amount is (sv)',
  increase: 'KOROTA (sv)',
  timeToMakeAnOffer: 'Aikaa tehdä tarjous (sv)',
  nSeconds: '{{ n }} sek (sv)',
  timerLength: 'Tarjousajan pituus (sv)',
  startAgain: 'ALOITA UUDESTAAN (sv)',
  pause: 'PYSÄYTÄ (sv)',
  resume: 'JATKA (sv)',
  next: 'SEURAAVA (sv)',
  liveAuctionHasEndedAt: 'Live auction has ended at {{ date }} (sv)',
  paletteNumber: 'Palette number (sv)',
  fieldShouldBeUnique: 'This field should be unique (sv)',
  liveAuction: 'Live auction (sv)',
  shouldBeInteger: 'This field should be integer',
  attachUserOnBid: 'Attach user on bid (sv)',
  complete: 'Complete (sv)',
  bidding: 'Bidding (sv)',
  bidder: 'Bidder (sv)',
  nextItem: 'Seuraava kohde',
  itemNumberNofT: 'Kohdenumero {{ n }} / {{ t }}',
  raise: 'KOROTUS',
  minimumRise: 'Korotus',
  minimumRiseN: 'Korotus (minimi {{ n }} €)',
  closeCurrentItem: 'MERKKAA JA SULJE KOHDE',
  autopilot: 'AUTOPILOT PÅ (sv)',
  manualMode: 'MANUELL (sv)',
  enableAutopilot: 'Aktivera autopilot (sv)',
  disableAutopilot: 'Stoppa autopilot (sv)',
  hammerDelay: 'Klubbfördröjning (sv)',
  hammerDelayHelp:
    'Hur länge autopiloten väntar efter att budtiden tagit slut innan objektet klubbas. Sena bud räknas fortfarande och startar om budtiden. (sv)',
  orders: 'Orders (sv)',
  items: 'Items (sv)',
  phoneNumber: 'Phone Number (sv)',
  bidCount: 'Bid count (sv)',
  myWork: 'My work (sv)',
  clients: 'Clients (sv)',
  editClientN: 'Edit client {{ holmastoId }} (sv)',
  userDocuments: 'User Documents (sv)',
  note: 'Note (sv)',
  notes: 'Notes (sv)',
  inWarehouse: 'In warehouse (sv)',
  auctionStatus: 'Auction status (sv)',
  maxBiddingLevel: 'Max bidding level (sv)',
  copyProduct: 'Copy Product (sv)',
  productWasSaved: 'Product was saved (sv)',
  productWasCreated: 'Product was created (sv)',
  publishOnline: 'Publish Online (sv)',
  markAsFeatured: 'Mark as featured (sv)',
  itemsCountN: 'Items count: {{ n }} (sv)',
  bidsCountN: 'Bids count: {{ n }} (sv)',
  auctionN: 'Auction {{ n }} (sv)',
  itemsSoldN: 'Sold items: {{ n }} (sv)',
  trendingItems: 'Trending Items (sv)',
  trendingCategories: 'Trending Categories (sv)',
  price: 'Pris',
  unpublish: 'Unpublish (sv)',
  compensate: 'Compensate (sv)',
  undoCompensation: 'Undo Compensation (sv)',
  compensated: 'Compensated (sv)',
  yes: 'Ja',
  no: 'Nej',
  sum: 'Sum (sv)',
  commission: 'Commission (sv)',
  sellerReceives: 'Seller receives (sv)',
  sellerCommissions: 'Seller Commissions (sv)',
  sellerCommissionWasUpdated: 'Seller commission was updated (sv)',
  update: 'Uppdatera',
  auctionHasUnpublishedProducts: 'Auction has unpublished product, would you like to continue? (sv)',
  editSeller: 'Edit Seller',
  sellers: 'Sellers (sv)',
  accountNumber: 'Bank account number (sv)',
  bankAccountWillBeReadFromCustomerDetails: 'Kontonummer hämtas från kunduppgifter',
  countries: 'Countries (sv)',
  none: 'None (sv)',
  receptionWasSaved: 'Reception was saved (sv)',
  profileMissingRequiredFields: 'Kundprofilen saknar obligatorisk information:',
  attachedCard: 'Attached Card',
  lastDigits: 'Last Digits',
  expirationDate: 'Expiration Date',
  accountType: 'Account Type (sv)',
  personal: 'Personal (sv)',
  business: 'Business (sv)',
  businessId: 'FO-nummer',
  contactPerson: 'Contact Person (sv)',
  handlingOrganizationName: 'Handling Organization Name (sv)',
  shippingOrderStatus: 'Shipping order status (sv)',
  manageOrder: 'Manage order (sv)',
  manageShippingOrder: 'Manage shipping order (sv)',
  verified: 'Is verified (sv)',
  serialNumber: 'Serial Number (sv)',
  zipCode: 'Zip code (sv)',
  liveAuctionStarted: 'Live auction started (sv)',
  liveAuctionEnded: 'Live auction ended (sv)',
  shippingIsSameAsBilling: 'Shipping address is same as billing address (sv)',
  shippingAddress: 'Shipping Address (sv)',
  billingAddress: 'Billing Address (sv)',
  nationality: 'Nationality (sv)',
  bidLimitRequests: 'Bid Limit requests (sv)',
  disabled: 'Disabled (sv)',
  editBid: 'Edit bid (sv)',
  notifyWhenBidIsWinning: 'Notify when bid is winning (sv)',
  notifyWhenBidIsntWinning: "Notify when bid isn't winning (sv)",
  notifications: 'Notifications (sv)',
  wrongCredentials: 'Wrong Credentials (sv)',
  generateExcel: 'Generate Excel (sv)',
  alreadyCompensated: 'Already compensated (sv)',
  sellerGets: 'Seller gets (sv)',
  invoice: 'Invoice (sv)',
  approvedReceptions: 'Approved Receptions (sv)',
  passwordConfirmation: 'Password confirmation (sv)',
  passwordShouldBeMinimum: 'Password should be kinimum {{ minimum }} (sv)',
  passwordsMustMatch: 'Passwords must match (sv)',
  unknownError: 'Unknknown error (sv)',
  serverErrorTryAgain: 'Serverfel, försök igen',
  isWinning: 'Is winning (sv)',
  userName: 'User Name (sv)',
  lotNumber: 'Lot number (sv)',
  marginalRate: 'Marginal rate (sv)',
  vatPercent: 'Vat percent (sv)',
  openOrders: 'Open orders (sv)',
  createWebshopOrder: 'Create webshop order (sv)',
  sellerCommission: 'Säljarprovision',
  buyerCommission: 'Köparprovision',
  generateSoldProductExcel: 'Generate sold product excel (sv)',
  system: 'Ennakkotarjous (sv)',
  online: 'Online (sv)',
  facilitator: 'Sali (sv)',
  wonItems: 'Won items (sv)',
  wonPrice: 'Won price (sv)',
  receptions: 'Receptions (sv)',
  soldProducts: 'Sold products (sv)',
  paidWith: 'Paid with (sv)',
  shipment: 'Shipment (sv)',
  total: 'Total (sv)',
  view: 'View (sv)',
  open: 'Open (sv)',
  closed: 'Sluten',
  deadline: 'Deadline (sv)',
  openReceptionIAmPersonalAssigned: 'Open receptions where I am personnel assigned (sv)',
  pendingReceptionsAssignedToMe: 'Väntande mottagningar',
  readyToSendReceptionsAssignedToMe: 'Mottagningar färdiga att skickas',
  sendReminder: 'Påminn om värdering',
  remind: 'Påminnelse',
  reminderWasSent: 'Påminnelse skickad',
  openReceptionIAmExpert: 'Open receptions where I am expert (sv)',
  id: 'ID (sv)',
  daysBeforeDeadline: 'Days before deadline (sv)',
  openItemAcceptancesWhereIAmAssignedReception: 'Open item acceptances where I am personnel assigned in reception (sv)',
  openItemAcceptancesWhereIAmAssigned: 'Open item acceptances where I am personnel assigned (sv)',
  receptionId: 'Reception ID (sv)',
  receptionPersonell: 'Reception Personell (sv)',
  customerName: 'Customer name (sv)',
  sellerName: 'Seller name (sv)',
  bidsTotal: 'Bids total (sv)',
  uniqueCustomersWithBids: 'Unique customers with bids (sv)',
  itemsWithBids: 'Items with bids (sv)',
  sumOfWinningPreBids: 'Sum of winning pre bids (sv)',
  sumOfWinningLiveBids: 'Sum of winning live bids (sv)',
  soldItems: 'Sålda objekt',
  categoriesWithMostBids: 'Categories with most bids (sv)',
  kpi: 'KPI (sv)',
  auctionTotals: 'Auction totals (sv)',
  openReceptions: 'Open receptions (sv)',
  openItems: 'Open items (sv)',
  newCustomers: 'New customers (sv)',
  requestedAt: 'Requested at (sv)',
  payments: 'Payments (sv)',
  totalSum: 'Total sum (sv)',
  completedOrders: 'Completed orders (sv)',
  shippingMethod: 'Shipping Method (sv)',
  buyerPays: 'Buyer pays (sv)',
  orderItems: 'Order items (sv)',
  acceptedReceptionProposals: 'Accepted reception proposals (sv)',
  notCompensated: 'Not compensated (sv)',
  numberOfItems: 'Number of items (sv)',
  paymentStatus: 'Payment status (sv)',
  compensationStatus: 'Compensation status (sv)',
  fee: 'Fee (sv)',
  sellerItems: 'Seller Items (sv)',
  sellerSoldItems: 'Seller sold items (sv)',
  compensatedWithoutPurchaseInvoice: 'Compensated without purchase invoice (sv)',
  compensateSeller: 'Compensate Seller (sv)',
  createPurchaseInvoices: 'Create purchase invoice for selected (sv)',
  markPaidInStore: 'Mark paid in store (sv)',
  language: 'Language (sv)',
  generateContract: 'Generate contract (sv)',
  verificationMethod: 'Verification method (sv)',
  basic_info_filled: 'Basic info filled (sv)',
  copyProductToNewAuction: 'Copy product to new auction ((SV)',
  copyToAuction: 'Copy to auction ((SV)',
  totalCommission: 'Total Commission (sv)',
  boughtBy: 'Bought by (sv)',
  buyerUnknown: 'Köpare okänd',
  unsavedChangesPrompt: 'There are some unsaved changes',

  clientWasUpdated: 'Client was updated (sv)',
  clientWasCreated: 'Client was created (sv)',
  categoryWasUpdated: 'Category was updated (sv)',
  categoryWasCreated: 'Category was created (sv)',
  tagWasUpdated: 'Tag was updated (sv)',
  tagWasCreated: 'Tag was created (sv)',
  receptionWasUpdated: 'Reception was updated (sv)',
  receptionWasCreated: 'Reception was created (sv)',
  timerIsStillActive: 'Timer is still active (sv)',
  onlineCustomers: 'Online Customers (sv)',
  otherCustomers: 'Other Customers (sv)',
  evaluation: 'Värdering',
  toSell: 'Försäljning',
  estateInventory: 'Boupptäckning',
  insuranceEvaluation: 'Försäkringvärdering',
  gemmologicalExamination: 'Gemmologisk undersökning',
  purposeOfSale: 'Uppdragets syfte',
  toAuction: 'Till auktion',
  salesOrder: 'Komissförsäljning',
  notifySeller: 'Notify seller (sv)',
  oneTimeCustomers: 'Engångskunder',
  paidInStore: 'Paid in store (sv)',
  before: 'Före',
  after: 'Efter',
  verifyUsers: 'Verify users (sv)',
  internalError: 'Internal Error (sv)',
  proposal: 'Proposal',
  proposalPdf: 'Proposal PDF (sv)',
  printTheReceptionReceipt: 'Skriv ut reception kvitto',
  enableEdit: 'Enable edit (sv)',
  disableEdit: 'Ota pois käytöstä (sv)',
  approved: 'Approved (sv)',
  created: 'Påbörjad',
  readyToSend: 'Färdig att skickas',
  published: 'Publiserad',
  declined: 'Icke godkänd',
  auctionCountdown: 'Auction should start in {{ m }} Months, {{ d }} days, {{ h }} hours, {{ s }} seconds (sv)',
  notifyUsersToPay: 'Notify users to pay (sv)',
  sentWaitingForAnswer: 'Skickad, väntar på svar',
  liveAuctionWillStartIn: 'Live-auktionen startar om',
  other: 'Annan',
  pendingEmails: 'Verifieringar av inloggnings-e-post',
  resendEmail: 'Skicka email igen',
  yourRequestHasCompleted: 'Skicka ett email:  Ditt uppdrag har slutförts',
  userWasAlreadyNotifiedNotifyAgain: 'Email was already send. Do you want to send again? (sv)',
  companyName: 'Företagsnamn',
  proposalSent: 'Erbjudande skickat',
  tools: 'Verktyg',
  management: 'Hantering',
  notifiSellerReceptionReceived: 'Skicka ett email: Vi har tagit emot dina föremål för utvärdering',
  printTheQrCode: 'Skriv ut QR coden',
  qrCodeError: 'QR-koden kan inte skapas: produkt-ID saknas',
  directPurchase: 'Direktköp',
  notifyReceptionEvaluationHasCompleted: 'Skicka ett email: Värderingen är färdig!',
  printSalesReceipt: 'Skriv ut köpeavtal försäljningskontrakt',
  createPurchaseInvoice: 'Skapa inköpsfaktura',
  purchaseInvoiceWasCreated: 'Inköpsfaktura skapades',
  sendSalesContract: 'Skicka ett email: Försäljningskontrakt',
  printSalesContract: 'Skriv ut  försäljningskontrakt',
  notificationWasSent: 'Avisering skickades',
  startLiveAuction: 'Starta live auktionen',
  auctionHasNoProducts: 'Vänligen lägg till produkter på auktionen innan du börjar live auktionen',
  updateFastTrackReception: 'Uppdatera snabbköpet',
  saveChanges: 'Spara ändringarna',
  unPublished: 'Opublicerad',
  markAsCompensated: 'Märk som betald i butiken',
  address: 'Adress',
  phone: 'Telefonnummer',
  fastTrackReceptionWasUpdated: 'Snabbköp updaterad',
  fastTrackReceptionWasCreated: 'Fast track reception was created (sv)',
  add: 'Add (sv)',
  history: 'History (sv)',
  cash: 'Kontant',
  netvisor: 'Netvisor',
  paymentMethod: 'Betalningsmetod',
  taxClass: 'Skatteklass',
  fastBuyItems: 'Handelsprodukter',
  productCantBePublished: "Productb {{ sku }} can't be published",
  setStatus: 'Uppdatera status för valda produkter',
  accountNumberIsRequired: 'In order to create purchase invoice fill account number',
  fastTrackReceptions: 'Snabbköp',
  addRow: 'Ny rad',
  addItem: 'Nytt föremål',
  receipts: 'Verifikat',
  addFastTrackReception: 'Fyll i nytt köp',
  socialSecurityNumber: 'Födelsedatum samt signum',
  form: 'Blankett',
  createSalesContract: 'Gör försäljningsavtal',
  runningNumber: 'Running number',
  productWasUnsold: 'Product was unsold (sv)',
  sellToUser: 'Sell to user (sv)',
  youReAboutToChangeAssignedAuctionId: "You're about to change assigned auction (sv)",
  youCantChangeSoldProductsAuction: "You can't change assigned auction for sold product (sv)",
  itemWasSoldToTheUser: 'Items as sold to user (sv)',
  printActions: 'Print actions',
  editProduct: 'Edit product',
  unlockForEditing: 'Unlock for editing',
  lockForEditing: 'Lock for editing',
  afterAuctionTools: 'After auction tools',
  unsell: 'Unsell',
  purchaseItemToHolmasto: 'Purchase item to holmasto',
  moveToAnotherAuction: 'Move to another auction',
  previewProductInCatalogue: 'Preview auction in catalogue',
  returnedToSeller: 'Returned to seller (sv)',
  sold: 'Såld',
  current: 'Current (sv)',
  waiting: 'Waiting (sv)',
  biddingEnded: 'Bidding ended (sv)',
  readyForCatalogue: 'Färdig för katalog',
  accepted: 'Godkänd',
  actions: 'Actions (sv)',
  soldToHolmasto: 'Sold to holmasto (sv)',
  movedFromEarlierAuction: 'Moved from earlier auction (sv)',
  itemCreated: 'Skapad',
  updated: 'Uppdaterad',
  grouped: 'Objekt',
  list: 'Senaste bud',
  type: 'Typ',
  verfictionStatus: 'Verifieringsstatus',
  disableFromCatalogue: 'Disable from catalogue (sv)',
  enableInCatalogue: 'Enable in catalogue (sv)',
  featuredImages: 'Featured Images (sv)',
  startPrice: 'Start price',
  filterItemDescription: 'Filter item description',
  copy: 'Copy',
  historyItems: 'History items (sv)',
  itemWasCompied: 'Item was copied',
  createWebshopProduct: 'Create webshop product',
  webshopProduct: 'Webshop product',
  editWebshopProduct: 'Edit webshop product ({{ lang }})',
  showFullTable: 'Show full table (sv)',
  tempId: 'Tillfälligt id',
  archived: 'Arkistoitu (sv)',
  archive: 'Archive',
  unarchive: 'Unarchive',
  proposalWasSent: 'Sales contract was sent',
  holmastoItems: 'Holmastos objekt',
  customerItems: 'Kundernas objekt',
  allItems: 'Alla objekt',
  customerDistribution: 'Kundfördelning',
  notSoldItems: 'Ej sålda objekt',
  avgPrice: 'Genomsnittspris',
  startingAvgPrice: 'Genomsnittligt utropspris',
  holmastoSalesTotal: 'Holmasto försäljning totalt',
  buyerCommissionTotal: 'Köparens provision totalt',
  sellerPayoutTotal: 'Säljarens utbetalning totalt',
  collapseAll: 'Fäll ihop alla',
  expandAll: 'Expandera alla',
  checkingSyncStatus: 'Kontrollerar synkroniseringsstatus...',
  errorCheckingSyncStatus: 'Fel vid kontroll av synkroniseringsstatus',
  productsInSync: 'Produkterna är synkroniserade',
  productsOutOfSync: 'Produkterna är inte synkroniserade',
  missingProducts: '{{count}} produkt(er) saknas från auktionen',
  extraProducts: '{{count}} extra produkt(er) i auktionen',
  outdatedProducts: '{{count}} produkt(er) behöver uppdateras',
  syncNow: 'Synkronisera nu',
  syncing: 'Synkroniserar...',
  syncCompleted: 'Synkronisering klar: {{added}} tillagd, {{updated}} uppdaterad, {{removed}} borttagen',
  syncFailed: 'Synkronisering misslyckades',
  lotNumbersLockedSyncNote:
    'Obs: Lotnummer är låsta (katalog publicerad eller förhandsbud startat) - endast befintliga produkter kommer att uppdateras. Inga produkter läggs till eller tas bort (lotnummer bevaras). Kategorihierarkier kommer att omberäknas.',
  generatePreviewCatalogue: 'Skapa förhandsgranskningskatalog (privat)',
  generatePublicCatalogue: 'Skapa offentlig katalog',
  generatePublicCatalogueWithHammerPrice: 'Skapa offentlig katalog med klubbpris',
  productsOutOfSyncConfirmPublish:
    'Produkterna är inte synkroniserade! Publicering nu kan visa felaktig information till kunder. Vill du publicera ändå?\n\nRekommendation: Klicka Avbryt, klicka sedan på "Synkronisera nu"-knappen ovanför produkterna och publicera därefter.',
  viewOutOfSyncDetails: 'Visa produkter som inte är synkroniserade',
  reason: 'Anledning',
  'syncReason.missing': 'Saknas från auktionen',
  'syncReason.extra': 'Extra i auktionen',
  'syncReason.outdated': 'Föråldrad',
  'syncReason.fields': 'Fält föråldrade',
  'syncReason.categories': 'Kategorier föråldrade',
  'syncReason.fields, categories': 'Fält och kategorier föråldrade',
  nonPublishedAssignedProducts: '{{count}} tilldelad(e) produkt(er) ännu inte publicerad(e)',
  nonPublishedAssignedProductsNote:
    'Dessa produkter är tilldelade denna auktion men har inte publicerats ännu. De kommer att visas i auktionens underkollektion när deras status ändras till "publicerad" (Färdig för katalog).',
  viewNonPublishedProducts: 'Visa opublicerade produkter',
  accountType_personal: 'Privatkund',
  accountType_business: 'Företagskund',
  accountTypeMissing: 'Kontotyp saknas',
  close: 'Close (sv)',
  erasurePreviewIntro:
    'These records may belong to the same person. The client to erase and records of the same person are selected; review the rest and select the ones to erase. (sv)',
  erasureConfidence_requested: 'Client to erase (sv)',
  erasureConfidence_likely: 'Probably the same person (sv)',
  erasureConfidence_possible: 'Possibly the same person (sv)',
  erasureMatchedBy: 'Found by (sv)',
  erasureMatch_personalId: 'Personal identity code (sv)',
  erasureMatch_email: 'Email (sv)',
  erasureMatch_authEmail: 'Login email (sv)',
  erasureMatch_phone: 'Phone (sv)',
  erasureViaCandidate: 'via another record (sv)',
  erasureDiffers: 'Differs (sv)',
  erasureActivity_bids: 'Bids (sv)',
  erasureActivity_orders: 'Orders (sv)',
  erasureActivity_receptions: 'Receptions (sv)',
  erasureActivity_fastTrackReceptions: 'Fast track receptions (sv)',
  erasureActivity_sellerCommissions: 'Seller commissions (sv)',
  erasureKind_fastTrackReception: 'Legacy fast track reception without a profile (sv)',
  holmastoId: 'Holmasto ID (sv)',
  erasureColumn_record: 'Record (sv)',
  erasureColumn_contact: 'Contact details (sv)',
  erasureColumn_comparison: 'Compared with the request (sv)',
  erasureColumn_status: 'Activity and status (sv)',
  erasureRequestedProfile: 'Other records are compared with this one (sv)',
  erasureBlocked: 'Erasure is not possible until these are resolved (sv)',
  erasureBlocker_bidInOpenAuction: 'Bid in an auction that has not ended (sv)',
  erasureBlocker_uncompensatedFastTrackReception: 'Uncompensated fast track reception (sv)',
  erasureBlocker_uncompensatedSellerCommission: 'Uncompensated seller commission (sv)',
  erasureBlocker_staffAccount: 'Staff account, not erased here (sv)',
  erasureRetention: 'Kept until {{date}} (sv)',
  erasureRetention_seller: 'Seller (sv)',
  erasureRetention_buyer: 'Buyer (sv)',
  erasureRetainedInfo:
    'Identification details of {{count}} selected records are kept for six years from the end of the year of their last purchase or sale. Everything else is erased. (sv)',
  erasureSelected: '{{count}} records selected. (sv)',
  erasureWarning_openReception: 'Unfinished reception (sv)',
  erasureWarning_unpaidOrder: 'Unpaid order (sv)',
  erasureCheckBefore: 'Check before erasing (sv)',
  erasureConfidence_certain: 'Same person (sv)',
  erasureMatch_accountNumber: 'Account number (sv)',
  erasureMatch_surnameAndBirthDate: 'Surname and birth date (sv)',
  erasureMatch_nameAndPostalCode: 'Name and postal code (sv)',
  erasureConflicts: 'Conflict (sv)',
  erasureConflict_personalId: 'Different personal identity code (sv)',
  erasureConflict_name: 'Different name (sv)',
  erasureBirthDate: 'Birth date (sv)',
  erasurePersonalId: 'Personal identity code (sv)',
  erasureAccountNumber: 'Account number (sv)',
  erasureComparison_same: 'same (sv)',
  erasureComparison_different: 'different (sv)',
  erasureWarning_thirdPartyName: "The name field may hold another person's details (sv)",
  back: 'Back (sv)',
  erasureOpen: "Erase client's data (sv)",
  erasureTitle: "Erase client's data (sv)",
  erasureNoOthersFound:
    'No other client records that might belong to the same person were found. The search used the personal identity code, email, phone number, account number and name. (sv)',
  erasureStep_select: 'Client records (sv)',
  erasureStep_verify: 'Request and identification (sv)',
  erasureStep_summary: 'Review and erase (sv)',
  erasureStep_done: "Client's data erased (sv)",
  erasureContinue: 'Continue (sv)',
  erasureShowSummary: 'Show what will be erased (sv)',
  erasureErase: 'Erase permanently (sv)',
  erasureConfirm: 'Erase the data of {{count}} records permanently? This cannot be undone. (sv)',
  erasureDone: 'The data has been erased and the erasure logged. Do the manual steps below. (sv)',
  erasureSummaryIntro: 'Nothing has been erased yet. (sv)',
  erasureErrorBlocked: 'Erasure is blocked: one of the selected records has changed. Open the erasure again. (sv)',
  erasureErrorWarnings: 'Acknowledge the warnings before erasing. (sv)',
  erasureErrorInvalid:
    'Check the details: the selection or the form is not valid. Open the erasure again if the records have changed. (sv)',
  erasureRequestReceivedAt: 'Request received (sv)',
  erasureRequestReceivedAtHelp: 'The reply is due within a month of this day. (sv)',
  erasureNoPersonalData: 'Do not enter identity codes or document numbers: the fields go to the erasure log. (sv)',
  erasureVerificationMethod: 'How was the identity verified? (sv)',
  erasureMethod_emailRequest: 'The request came from the registered email address (sv)',
  erasureMethod_sms: 'SMS code to the registered phone number (sv)',
  erasureMethod_email: 'Confirmation from the registered email address (sv)',
  erasureMethod_emailHelp: 'A separate message to the registered address that the customer answered (sv)',
  erasureMethod_inPerson: 'Identity document checked in person (sv)',
  erasureMethod_other: 'Other method (sv)',
  erasureMethod_otherDescription: 'Describe the method (sv)',
  erasureReferenceHelp: 'E.g. the email subject or a ticket number. (sv)',
  erasureVerifiedAt: 'Verified on (sv)',
  erasureReference: 'Where the request is (sv)',
  erasureWarningsAcknowledged: 'I have checked these before erasing: (sv)',
  erasureAcknowledge_openReception: 'open receptions have been handled and the items returned (sv)',
  erasureAcknowledge_unpaidOrder: 'unpaid orders will no longer be collected (sv)',
  erasureAcknowledge_thirdPartyName: 'other people’s details in the name fields have been resolved (sv)',
  erasureWillDelete: 'Will be deleted (sv)',
  erasureDeleted: 'Deleted (sv)',
  erasureWillClear: 'Personal data will be cleared (sv)',
  erasureCleared: 'Personal data cleared (sv)',
  erasureKeptUntil: 'Identification data is kept until {{date}}. (sv)',
  erasureKeptDocuments: 'Identity documents kept: {{count}}. (sv)',
  erasureNothingKept: 'Nothing is kept. (sv)',
  erasureKeptWithoutDetails: "Kept without the client's details (sv)",
  erasureKept_bids: 'bids (sv)',
  erasureKept_orders: 'orders (sv)',
  erasureCopy: 'Copy (sv)',
  erasureCopied: 'Copied (sv)',
  erasureManualSteps: 'After erasing, do by hand (sv)',
  erasureManual_woocommerce:
    'WooCommerce: open the WordPress personal data eraser and do this for each email below (sv)',
  erasureManual_woocommerceStep_paste: 'Copy the email into "Username or email address" (sv)',
  erasureManual_woocommerceStep_noConfirmation:
    'Untick "Send personal data erasure confirmation email.": the identity is already verified. With it ticked WordPress waits for the customer to confirm and erases nothing. (sv)',
  erasureManual_woocommerceStep_erase: 'Press "Send Request", then "Erase personal data" on the request row (sv)',
  erasureManual_noEmail: 'The selected records have no email (sv)',
  erasureManual_reply: 'Reply to the customer: what was erased and what is kept (sv)',
  erasureManual_thirdParty:
    "A name field holds another person's details: handle it separately, the request covers only the requester's own data (sv)",
  erasureCount_authUser: 'MyHolmasto login (sv)',
  erasureCount_profile: 'client profile (sv)',
  erasureCount_profileSubcollections: 'notes, card verification details and wishlist (sv)',
  erasureCount_storageFiles: 'uploaded files (sv)',
  erasureCount_changelogsDeleted: "the client's change log (sv)",
  erasureCount_rateLimits: 'login attempt counters (sv)',
  erasureCount_products: 'products (sv)',
  erasureCount_receptions: 'receptions (sv)',
  erasureCount_receptionExperts: 'reception expert copies (sv)',
  erasureCount_paletteUsers: 'palette numbers (sv)',
  erasureCount_sellerCommissions: 'seller commissions (sv)',
  erasureCount_fastTrackReceptions: 'fast track receptions (sv)',
  erasureCount_changelogsScrubbed: 'changelogs of other records (sv)',
})

export default sv
